export const CLASS_NAMES = {
  label: 'text-style-j-em-up normal-case md:text-style-g max-w-24 text-right',
};
